import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { updateAmount, updateNote } from '../../actions/orderActions'
import IconCheck from '../../assets/icons/IconCheck'
import IconClose from '../../assets/icons/IconClose'
import IconRefresh from '../../assets/icons/IconRefresh'
import FormatCurrency from '../../components/elements/FormatCurrency'
import useDidMountEffect from '../../hooks/useDidMountEffect'
import useMoney from '../../hooks/useMoney'
import { getDisplayFoodName, getFoodPriceShow, reMapBeilage } from '../../utils'
import { clsx } from '../../utils/helper'

const ICON_STATE = [IconRefresh, IconCheck]

const FoodInCart = ({ food, orderState, indexInCart, editable }) => {
    const dispatch = useDispatch()
    const boxRef = useRef()
    const { t } = useTranslation()

    const { foodDetails, amount, note } = food
    const { currentPrice, originPrice } = useMoney(getFoodPriceShow, foodDetails)
    const [isShowNote, setIsShowNote] = useState(false)
    const [noteValue, setNoteValue] = useState('')

    const enableSubmit = noteValue !== note

    let toppingShow = [...reMapBeilage(food), { name_food: note }].filter(
        el => !!el?.name_food
    )

    let iconShow = IconClose
    if (orderState !== undefined) {
        iconShow = ICON_STATE[orderState]
    }

    const handleUpdateAmount = amount => {
        dispatch(
            updateAmount({
                amount,
                index: indexInCart,
                groupOrder: food.groupOrder,
            })
        )
    }

    const handleDelete = () => {
        dispatch(
            updateAmount({
                amount: 0,
                index: indexInCart,
                groupOrder: food.groupOrder,
            })
        )
    }

    const handleSubmitNote = () => {
        // if (!enableSubmit) {
        //     return
        // }

        dispatch(
            updateNote({
                note: noteValue || '',
                index: indexInCart,
                groupOrder: food.groupOrder,
            })
        )

        setIsShowNote(false)
    }

    useDidMountEffect(() => {
        setNoteValue(isShowNote ? note || '' : '')
    }, [isShowNote])

    useEffect(() => {
        // const className = `food-add-ani-${amount}`
        const className = 'food-add-ani'
        boxRef.current.classList.add(className)
        const timeOut = setTimeout(() => {
            boxRef.current && boxRef.current.classList.remove(className)
        }, 400)
        const wh50 = window.innerHeight / 2
        document.getElementById('cart-content').scrollTop = Math.max(
            0,
            boxRef.current.offsetTop - wh50
        )

        return () => {
            timeOut && clearTimeout(timeOut)
            boxRef.current && boxRef.current.classList.remove(className)
        }
    }, [amount])

    return (
        <div ref={boxRef} className="food-desk-added-box">
            <div className="food-desk-added">
                <div className="change-amount">
                    {editable && (
                        <div
                            className="sub"
                            onClick={() => handleUpdateAmount(-1)}
                        >
                            -
                        </div>
                    )}
                    <div className="amount">{amount}</div>
                    {editable && (
                        <div
                            className="add"
                            onClick={() => handleUpdateAmount(1)}
                        >
                            +
                        </div>
                    )}
                </div>
                <div className="info">
                    <div className="name">{getDisplayFoodName(foodDetails)}</div>
                </div>
                <div className="btn-edit" onClick={() => setIsShowNote(true)}>
                    {editable && <i className="fas fa-pen" />}
                </div>
                <div className="money">
                    <FormatCurrency amount={currentPrice * amount} />
                    {!!originPrice && (
                        <div className="origin label-3">
                            <FormatCurrency amount={originPrice * amount} />
                        </div>
                    )}
                </div>
                <div className="btn-delete">
                    {editable && (
                        <i
                            onClick={handleDelete}
                            className="far fa-trash-alt"
                        />
                    )}
                </div>
            </div>
            {!!toppingShow.length && (
                <div className="beilage-added">
                    {toppingShow.map((beilage, index) => (
                        <div className="flex-between" key={index}>
                            <span>{beilage.name_food}</span>
                            {!!beilage.price && <FormatCurrency amount={beilage.price * amount} />}
                        </div>
                    ))}
                </div>
            )}
            {isShowNote ? (
                <div className="note-box mt-1">
                    <textarea
                        value={noteValue}
                        onChange={e => setNoteValue(e.target.value)}
                        rows="4"
                        placeholder={`${t('cartDesktop.lbNote')} ...`}
                        autoFocus
                    ></textarea>
                    {/* <button
                        className="secondary-button"
                        onClick={() => setIsShowNote(false)}
                    >
                        {t('cartDesktop.btnCancel')}
                    </button> */}
                    <button
                        className={clsx([
                            'secondary-button',
                            // enableSubmit ? 'active' : 'disable',
                        ])}
                        onClick={handleSubmitNote}
                    >
                        {t('cartDesktop.btnAgree')}
                    </button>
                </div>
            ) : null}
        </div>
    )
}

export default FoodInCart
